module.exports = __webpack_public_path__ + "static/img/sc.e6584421.svg";